<template>
  <div class="swiper">
    <div class="swiper-container">
      <div class="swiper-item" v-for="(item, i) in datas" :key="i" :class="getImgClass(i)"
           :ref='"img"+i'>
        <img :src="item.path" alt/>
        <div class="title" v-html="item.title"></div>
        <div class="words" v-html="item.words"></div>
      </div>
    </div>
    <div class="swiper-prev" @click.stop="transPrev">
    </div>
    <div class="swiper-next" @click.stop="transNext">
    </div>
  </div>
</template>

<script>

export default {
  name: 'ImgSwiperV6',
  props: {
    datas: { //数据源（必填）
      type: Array,
      default: () => {
        return [];
      },
    },
    interval: { //轮播间隔（单位：ms）
      type: Number,
      default: () => {
        return 3000;
      },
    },
    animationInterval: { //轮播执行动画间隔（单位：ms）
      type: Number,
      default: () => {
        return 400;
      },
    },
    moveDistance: { //需触发轮播的鼠标移动x轴最小距离（单位：px）
      type: Number,
      default: () => {
        return 100;
      },
    },
  },
  data() {
    return {
      oldCurrentIndex: -1,
      currIndex: 0,
      transing: false,
      rem: 100,
    };
  },
  mounted() {
    this.rem = document.documentElement.style.fontSize.replace('px', '') * 1;
    this.resetItemPosition();
    // this.refreshInterval();
  },
  unmounted() {
    clearInterval(this.intervalFun);
  },
  watch: {
    currIndex(newVal) {
      if (this.transing) {
        return;
      }
      this.transing = true;
      this.resetItemPosition();
      setTimeout(() => {
        this.transClear();
      }, this.animationInterval);
    },
  },
  methods: {
    transPrev() {
      this.currIndex = this.getPrevIndex(this.currIndex);
      // this.refreshInterval();
    },
    transNext() {
      this.currIndex = this.getNextIndex(this.currIndex);
      // this.refreshInterval();
    },
    transIndex(i) {
      if (this.transing) {
        return;
      }
      this.currIndex = i;
      // this.refreshInterval();
    },
    /**
     刷新定时器
     @param
     @return
     */
    refreshInterval() {
      clearInterval(this.intervalFun);
      this.intervalFun = setInterval(() => {
        this.currIndex = this.getNextIndex(this.currIndex);
      }, this.interval);
    },

    resetItemPosition() {
      this.datas.forEach((item, index) => {
        let translate = this.translateItem(index, this.currIndex);
        const img = this.$refs[`img${index}`][0];
        img.style.zIndex = this.getZIndex(index);
        img.style.transition = `all ${this.animationInterval / 1000}s`;
        img.style.transform = 'translateX(' + translate + 'px)';
      });
    },

    getZIndex(i) {
      if (i == this.currIndex) {
        return this.datas.length
      }
      if (this.currIndex == 0 && i == this.datas.length - 1) {
        // 第一个 要处理一下最后一个
        if (this.currIndex > this.oldCurrentIndex) {
          return 1
        }
        return 2
      } else if (this.currIndex == this.datas.length - 1 && i == 0) {
        // 最后一个 要处理一下第一个
        return 2
      }
      let isInStage = Math.round(Math.abs(i - this.currIndex)) <= 1;
      if (isInStage) {
        return 2
      }
      return 1
    },

    translateItem(index, currentIndex) {
      const isInStage = Math.round(Math.abs(index - currentIndex)) <= 2;
      return this.calcCardTranslate(isInStage, index, currentIndex);
    },

    calcCardTranslate(indexInStage, index, activeIndex) {
      // 统一配置轮播卡片的尺寸和间距
      const CARD_CONFIG = {
        width: 6,       // 卡片宽度 (rem)
        gap: 0.24,      // 卡片之间的间距 (rem)
        cardTotalWidth: 6.24 // 卡片宽度 + 间距 (6 + 0.24)
      };
      // 获取父容器宽度
      const parentWidth = this.$parent.$el.offsetWidth;
      const dataLength = this.datas.length;

      // 基础偏移量计算：每个卡片的总宽度（宽度+间距）
      const baseOffset = CARD_CONFIG.cardTotalWidth * this.rem;

      // 通用偏移计算（核心逻辑）
      const normalTranslate = (index - activeIndex) * baseOffset;

      // --- 修复首尾紧贴问题：增加完整的偏移量 ---
      // 第一个滑到最后一个：向左偏移 1 个完整卡片宽度+间距（保持间距）
      if (activeIndex === 0 && index === dataLength - 1) {
        return -baseOffset - CARD_CONFIG.gap * this.rem;
      }
      // 最后一个滑到第一个：向右偏移 1 个完整卡片宽度+间距（保持间距）
      else if (activeIndex === dataLength - 1 && index === 0) {
        return baseOffset + CARD_CONFIG.gap * this.rem;
      }
      // 倒数第二个/最后一个滑到前两个：偏移 2 个单位 + 间距
      else if (
          (activeIndex === dataLength - 2 && index === 0) ||
          (activeIndex === dataLength - 1 && index === 1)
      ) {
        return 2 * baseOffset + CARD_CONFIG.gap * this.rem;
      }

      // --- 常规场景处理 ---
      if (indexInStage) {
        // 可视区域内的卡片：基础偏移 + 间距补偿
        return normalTranslate + CARD_CONFIG.gap * this.rem;
      }
      else if (index < activeIndex) {
        // 左侧不可见卡片：统一向左偏移（保证和其他卡片间距一致）
        return -baseOffset - CARD_CONFIG.gap * this.rem;
      }
      else {
        // 右侧不可见卡片：偏移到父容器外（避免显示）
        return parentWidth;
      }
    },
    /**
     轮播滑动清空
     @param
     @return
     */
    transClear() {
      this.transing = false;
    },
    /**
     获取上一个序号
     @param {Number} i 序号
     @return {Number} 上一个序号
     */
    getPrevIndex(i) {
      if (i == 0) {
        return this.datas.length - 1;
      }
      return i - 1;
    },
    /**
     获取下一个序号
     @param {Number} i 序号
     @return {Number} 下一个序号
     */
    getNextIndex(i) {
      if (i == this.datas.length - 1) {
        return 0;
      }
      return i + 1;
    },
    /**
     获取图片class
     @param {Number} i 序号
     @return {String} 图片class
     */
    getImgClass(i) {
      if (i == this.currIndex) {
        return 'curr';
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
.swiper {
  position: relative;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;

  > .swiper-container {
    width: 99%;
    height: 100%;
    position: absolute;
    overflow: hidden;

    > .swiper-item {
      position: absolute;
      width: 6rem;
      height: 7.6rem;
      overflow: hidden;
      border-radius: 18px;

      > img {
        width: 100%;
        height: 100%;
        transition: all 0.4s;
        object-fit: cover;
      }

      > .title {
        height: 1.6rem;
        background: linear-gradient( 0deg, #3E2365 0%, #200F37 100%);
        font-size: 0.3rem;
        color: rgba(255,255,255,0.65);
        text-align: center;
        align-content: center;
        line-height: 0.42rem;
        position: absolute;
        bottom: 0;
        width: 100%;
      }

      > .words {
        font-size: 0.1rem;
        color: #efeeee;
        text-align: center;
        line-height: 0.15rem;
        position: absolute;
        bottom: 1.8rem;
        width: 100%;
      }
    }
  }
}

.swiper-prev {
  position: absolute;
  top: 50%;
  left: 0.9rem;
  transform: translateY(-50%);
  z-index: 99;
  width: 0.6rem;
  height: 0.6rem;
  background: url("../img/swiper-left.png") no-repeat center center;
  background-size: 100% 100%;
  cursor: pointer;

  &:hover {
    background: url("../img/swiper-left-hover.png") no-repeat center center;
    background-size: 100% 100%;
  }
}

.swiper-next {
  position: absolute;
  top: 50%;
  right: 0.9rem;
  transform: translateY(-50%);
  z-index: 99;
  width: 0.6rem;
  height: 0.6rem;
  background: url("../img/swiper-right.png") no-repeat center center;
  background-size: 100% 100%;
  cursor: pointer;

  &:hover {
    background: url("../img/swiper-right-hover.png") no-repeat center center;
    background-size: 100% 100%;
  }
}
</style>
